/** Counterpart to `file-upload.ts`'s `fileToBase64()` — triggers a browser
 * download for a GET endpoint that returns a file body (CSV/PDF export,
 * `Content-Disposition: attachment`). GET needs no CSRF token, but `orgId`
 * must be passed explicitly (this module has no access to `api.ts`'s
 * private `activeOrgId`). */
export async function downloadFile(path: string, filename: string, orgId?: string | null): Promise<void> {
  const headers: Record<string, string> = {};
  if (orgId) headers['X-Organization-Id'] = orgId;
  const res = await fetch(`/api${path}`, { headers, credentials: 'include' });
  if (!res.ok) throw new Error(`Download fehlgeschlagen (${res.status})`);
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
